export default function omitNestedObject(array, key, value) {
    return array.reduce((acc, item) => {
        if (item[key] === value) {
            return acc;
        }
        if (item.children) {
            item.children = omitNestedObject(item.children, key, value);
        }
        acc.push(item);
        return acc;
    }, []);
};
